import type { AttendanceRecord } from '@/mocks/db/schema';
import { CLOCKING_RECORDS_DEMO_ORG_ID } from '../-constants';

/**
 * Dexie 上の古い行や部分投入データとの互換用（一覧・出勤簿で共通）
 */
export function normalizeAttendanceRecordForDemo(r: AttendanceRecord): AttendanceRecord {
  const legacy = r as AttendanceRecord & {
    workplaceName?: string;
    approvalStatus?: AttendanceRecord['approvalStatus'];
    status?: AttendanceRecord['status'];
    organizationId?: string;
  };
  return {
    ...r,
    organizationId: legacy.organizationId ?? CLOCKING_RECORDS_DEMO_ORG_ID,
    workplaceName: legacy.workplaceName ?? '本社オフィス',
    approvalStatus: legacy.approvalStatus ?? 'approved',
    status: legacy.status ?? 'present'
  };
}